import { render, staticRenderFns } from "./CreateNewSubmissionCard.vue?vue&type=template&id=6170a7c2&scoped=true&"
import script from "./CreateNewSubmissionCard.vue?vue&type=script&lang=js&"
export * from "./CreateNewSubmissionCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewSubmissionCard.vue?vue&type=style&index=0&id=6170a7c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6170a7c2",
  null
  
)

export default component.exports